export default "__VITE_ASSET__Ch3q7B_s__"